import { EnumOption } from "./helpers";
import { Operator } from "./operators";

export enum ColumnKind {
  Boolean = "boolean",
  Date = "date",
  Enum = "enum",
  Money = "money",
  Number = "number",
  Text = "text",
  Time = "time",
}

// TODO: will likely need to extend with optional per-kind display info, e.g.:
// -- number kinds may specify precision (for display rounding) or percentage toggle
export interface ColumnDef {
  jsonKey: string;
  kind: ColumnKind;
  displayName: string;
  enums?: EnumOption[];
  orderFunc: (a: any, b: any) => number;
}

export type Schema = ColumnDef[];

export type DataObject = {
  [key: string]: boolean | number | string | null;
  loan_application_id: number;
};

export type Data = DataObject[];

export enum ActionKind {
  Filter = "filter",
  Sort = "sort",
}

/*
 * Filter & Action
 * DEHYDRATED DEFINITIONS
 */
type ActionDefBase = {
  kind: ActionKind;
  jsonKey: string;
};

export type FilterAction = ActionDefBase & {
  kind: ActionKind.Filter;
  operator: Operator;
  comparisonValue?: any;
};

export type SortAction = ActionDefBase & {
  kind: ActionKind.Sort;
  sortOrder: SortOrderKind;
};

export type ActionDef = FilterAction | SortAction;

/*
 * Filter & Action
 * HYDRATED DEFINITIONS
 * Some fields only get "hydrated" or computed after the serialized representation
 *  is computed through either getFilterAction or getSortAction
 */
type HydratedActionBase = ActionDefBase & {
  idx?: number;
  displayText: string;
};

export type HydratedFilterAction = HydratedActionBase &
  FilterAction & {
    func: Function;
  };

export type HydratedSortAction = HydratedActionBase & SortAction;

export type HydratedAction = HydratedFilterAction | HydratedSortAction;

export function isSortAction(action: ActionDef): action is HydratedSortAction {
  return action.kind === ActionKind.Sort;
}

export function isFilterAction(action: ActionDef): action is HydratedFilterAction {
  return action.kind === ActionKind.Filter;
}

export interface ColumnDisplay {
  jsonKey: string;
  visible: boolean;
}

export enum SortOrderKind {
  Ascending = "ascending",
  Descending = "descending",
}
